var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "19fdca15a24569d7192a6a25c2a4042a.png",
    width: 434,
    height: 440
});